"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const react_2 = require("@osmosys/react");
const hooks_1 = require("../../hooks");
const OsmosysConverter_1 = require("../../../../comps/OsmosysConverter");
const react_if_1 = require("react-if");
const Overlay_1 = require("./Overlay");
const HtmlPanel_1 = require("./HtmlPanel");
const utils_1 = require("../../../../panels/ContentImportPanel/utils");
exports.ConversionCanvasRunConversionView = () => {
    const { state: { draft, sampleInputHtml, sampleOutputHtml, sampleContentItem, sampleContentItemKey, run, }, } = hooks_1.useConversionCanvas();
    const { dispatchCanvasAction } = hooks_1.useConversionCanvasUpdate();
    react_1.useEffect(() => {
        if (run) {
            dispatchCanvasAction({
                data: {
                    run: false,
                },
                type: 'state',
            });
        }
    }, [
        dispatchCanvasAction,
        sampleInputHtml,
        sampleContentItem,
        sampleContentItemKey,
    ]);
    const onSampleSelect = react_1.useCallback((newVal) => {
        dispatchCanvasAction({
            data: { sampleInputHtml: newVal },
            type: 'state',
        });
    }, [dispatchCanvasAction]);
    const linkToPost = react_1.useMemo(() => {
        if (sampleContentItem) {
            const [l] = utils_1.getContentItemFieldData(sampleContentItem, 'link', '');
            if (l) {
                return l;
            }
        }
        return '';
    }, [sampleContentItem]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_2.OsmosysDiv, { flexColCenteredFilled: true },
            react_1.default.createElement(react_2.OsmosysDiv, { flexRowCenteredFilled: true },
                react_1.default.createElement(react_2.OsmosysDiv, { maxWidth: 960, className: "w-100", border: true, shadow: true, marginBottom: true, flexColFilled: true },
                    react_1.default.createElement(react_2.OsmosysDiv, { className: " position-relative" },
                        react_1.default.createElement(Overlay_1.ConversionCanvasRunConversionViewOverlay, { isOpen: run, disabled: !sampleInputHtml, onRun: () => {
                                dispatchCanvasAction({
                                    data: {
                                        run: true,
                                    },
                                    type: 'state',
                                });
                            } }),
                        react_1.default.createElement(react_if_1.When, { condition: run },
                            react_1.default.createElement(OsmosysConverter_1.OsmosysConverter, { contentStr: sampleInputHtml, conversions: [draft], linkToPost: linkToPost, run: run, onChange: newContentStr => {
                                    dispatchCanvasAction({
                                        data: {
                                            sampleOutputHtml: newContentStr,
                                        },
                                        type: 'state',
                                    });
                                }, onSuccess: newContentStr => {
                                    dispatchCanvasAction({
                                        data: {
                                            sampleOutputHtml: newContentStr,
                                        },
                                        type: 'state',
                                    });
                                }, onClose: () => { } }))),
                    react_1.default.createElement(HtmlPanel_1.ConversionCanvasRunConversionViewHtmlPanel, { onChange: onSampleSelect, sampleInputHtml: sampleInputHtml, sampleOutputHtml: sampleOutputHtml, sampleContentItem: sampleContentItem, sampleContentItemKey: sampleContentItemKey, toggleContentImportPanel: show => {
                            dispatchCanvasAction({
                                data: {
                                    showContentImportPanel: show,
                                },
                                type: 'state',
                            });
                        }, clearContentItem: () => {
                            dispatchCanvasAction({
                                data: {
                                    sampleContentItem: null,
                                    sampleContentItemKey: null,
                                },
                                type: 'state',
                            });
                        }, onContentItemKeyChange: newKey => {
                            dispatchCanvasAction({
                                data: {
                                    sampleContentItemKey: newKey,
                                },
                                type: 'state',
                            });
                        } }))))));
};
//# sourceMappingURL=index.js.map